import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../../modules/infra/i18n';
import CancelButton from '../../../../common/buttons/cancelButton';
import Modal from '../../../../common/Modal';
import { BulkUpdateFilters } from '../Filters';
import ProductItem from './ProductItem';

const StockTakingModal = (props) => {
  const {
    close,
    products,
    quantities,
    submitting,
    brandFilters,
    categoryFilters,
    allBrandsChecked,
    allCategoriesChecked,
    onCategoryFilterChange,
    onBrandFilterChange,
    searchText,
    onSearchChange,
    onQtyChange,
    onSubmit,
  } = props;

  return (
    <Modal close={close} showCloseButton title={t('products:bulk_inventory.stock_taking_title')}>
      <form className="c-inventory-form u-mv+ u-mh" onSubmit={onSubmit}>
        <BulkUpdateFilters
          brandFilters={brandFilters}
          categoryFilters={categoryFilters}
          allBrandsChecked={allBrandsChecked}
          allCategoriesChecked={allCategoriesChecked}
          onCategoryFilterChange={onCategoryFilterChange}
          onBrandFilterChange={onBrandFilterChange}
          searchText={searchText}
          onSearchChange={onSearchChange}
        />
        <div className="c-inventory-spacer" />
        <fieldset disabled={submitting} display-if={products.length}>
          <div className="ReactTable c-stock-taking-table c-inventory-table c-table-new c-no-hover u-table-layout-fixed u-width-100">
            <div className="rt-table">
              <div className="rt-thead">
                <div className="rt-tr">
                  <div className="rt-th u-flex-1">{t('products:bulk_inventory.product_name')}</div>
                  <div className="rt-th c-table-column__width-150">
                    {t('products:bulk_inventory.expected_inventory')}
                  </div>
                  <div className="rt-th c-table-column__width-150">{t('products:bulk_inventory.actual_inventory')}</div>
                  <div className="rt-th c-table-column__width-150">
                    {t('products:bulk_inventory.change_plus_minus')}
                  </div>
                  <div className="rt-th c-table-column__width-150">
                    {t('products:bulk_inventory.shrinkage_percent')}
                  </div>
                </div>
              </div>
              <div className="c-stock-taking-table__rows">
                {products.map((product) => (
                  <ProductItem
                    key={product.assignmentId}
                    product={product}
                    actualInventoryValue={quantities[product.assignmentId]}
                    onInputChange={onQtyChange(product.assignmentId)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="u-text-right u-mv+ u-mr+">
            <CancelButton onClick={close} content={t('products:bulk_inventory.cancel_button')} />
            <button type="submit" className="c-btn u-width-120 u-ml-">
              <span className="c-btn__text">{t('products:bulk_inventory.save_button')}</span>
            </button>
          </div>
        </fieldset>
      </form>
    </Modal>
  );
};

StockTakingModal.propTypes = {
  close: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  quantities: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  brandFilters: PropTypes.array.isRequired,
  categoryFilters: PropTypes.array.isRequired,
  allBrandsChecked: PropTypes.bool.isRequired,
  allCategoriesChecked: PropTypes.bool.isRequired,
  onCategoryFilterChange: PropTypes.func.isRequired,
  onBrandFilterChange: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onQtyChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default StockTakingModal;
